import { render, staticRenderFns } from "./PackageDescriptor.vue?vue&type=template&id=1db6b0a4&"
import script from "./PackageDescriptor.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports